export const APP_CONTEXT_ENTER = "tillsammans/APP_CONTEXT_ENTER";
export const APP_CONTEXT_LEAVE = "tillsammans/APP_CONTEXT_LEAVE";

export const USER_ENTERED_TILLSAMMANS = "tillsammans/USER_ENTERED_TILLSAMMANS";

export const LOAD_MY_TEAMS_ACTION = "tillsammans/LOAD_MY_TEAMS_ACTION";
